import { Provider } from 'react-redux'
import { PersistGate } from "redux-persist/integration/react"
import { persistor, store } from '../../store/store'
import LoaderComponent from '../CoreComponents/LoaderComponent'

export default function ReduxProvider({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <PersistGate loading={<LoaderComponent/>} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  )
}
